<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input clearable v-model="listQuery.path" :placeholder="$t('user.route')" style="width: 300px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <div class="filter-item">
        <el-date-picker
          v-model="listQuery.created_at"
          type="datetimerange"
          align="right"
          :start-placeholder="$t('user.startTime')"
          :end-placeholder="$t('user.endTime')"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        {{ $t('table.search') }}
      </el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="danger" icon="el-icon-delete" @click="handleClear">
        {{ $t('table.clear') }}
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column :label="$t('user.username')" width="200px">
        <template slot-scope="scope">
          {{ scope.row.admin ? scope.row.admin.username : '' }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('user.requestMethod')" prop="method" width="150px">
      </el-table-column>
      <el-table-column :label="$t('user.route')" prop="path" min-width="200px">
      </el-table-column>
      <el-table-column :label="$t('user.actionName')" prop="action_name" min-width="200px">
      </el-table-column>
      <el-table-column
        :label="$t('table.createdAt')"
        prop="created_at"
        width="170">
      </el-table-column>
      <el-table-column :label="$t('table.actions')" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">
            {{ $t('table.detail') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <el-dialog :title="textMap" :visible.sync="dialogFormVisible">
      <el-form @submit.native.prevent ref="dataForm" :rules="rules" :model="temp" label-position="right" :label-width="formLabelWidth" v-loading="dialogFormLoading">
        <el-form-item :label="$t('user.requestMethod')">
          <el-input v-model="temp.method" />
        </el-form-item>
        <el-form-item :label="$t('user.route')">
          <el-input v-model="temp.path" />
        </el-form-item>
        <el-form-item :label="$t('user.actionName')">
          <el-input v-model="temp.action_name" />
        </el-form-item>
        <el-form-item :label="$t('user.requestParams')+'(all)'">
          <json-editor ref="jsonEditor" v-model="temp.all_params" />
        </el-form-item>
        <el-form-item :label="$t('user.requestParams')+'(input)'">
          <json-editor ref="jsonEditor" v-model="temp.input_params" />
        </el-form-item>
        <el-form-item :label="$t('user.requestParams')+'(query)'">
          <json-editor ref="jsonEditor" v-model="temp.query_params" />
        </el-form-item>
        <el-form-item :label="$t('user.responseData')">
          <json-editor ref="jsonEditor" v-model="temp.res_data" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          {{ $t('table.cancel') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fetchList, fetchDetail, clear } from '@/api/operationLog'
import waves from '@/directive/waves' // Waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import JsonEditor from '@/components/JsonEditor'

export default {
  name: 'SystemOperationLog',
  components: { Pagination, JsonEditor },
  directives: { waves },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        path: undefined,
        created_at: ''
      },
      temp: {
        action_name: '',
        admin_id: 0,
        all_params: {},
        input_params: {},
        method: '',
        query_params: {},
        res_data: {},
        updated_at: '',
        created_at: '',
        _id: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      rules: {},
      dialogFormLoading: false
    }
  },
  computed: {
    formLabelWidth: function() {
      return this.$store.getters.language === 'zh' ? '130px' : '200px'
    },
    textMap: function() {
      return this.dialogStatus === 'update' ? this.$t('form.edit') : this.$t('form.create')
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      var params, startTime, endTime
      if (this.listQuery.created_at !== '' && this.listQuery.created_at !== null && this.listQuery.created_at !== undefined) {
        startTime = this.listQuery.created_at[0]
        endTime = this.listQuery.created_at[1]
      } else {
        startTime = ''
        endTime = ''
      }
      params = {
        page: this.listQuery.page,
        limit: this.listQuery.limit,
        path: this.listQuery.path,
        start_time: startTime,
        end_time: endTime
      }
      fetchList(params).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        action_name: '',
        admin_id: 0,
        all_params: {},
        input_params: {},
        method: '',
        query_params: {},
        res_data: {},
        updated_at: '',
        created_at: '',
        _id: ''
      }
    },
    handleUpdate(row) {
      this.dialogFormLoading = true
      this.resetTemp()
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
      fetchDetail(row._id).then((res) => {
        this.temp = res.data.detail
        this.dialogFormLoading = false
      })
    },
    handleClear() {
      this.$confirm('此操作将清空三个月之前的日志数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clear().then((res) => {
          if (res.code === 20000) {
            this.$message.success(this.$t('form.delSuccess'))
            this.handleFilter()
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
